const DASHBOARD_STATE_PREFIX = "influencer-dashboard-state";

const LEGACY_DASHBOARD_KEYS = [
  "influencer-live-campaign-filters",
  "influencer-live-scroll-position",
  "influencer-live-campaign-search",
];

const LEGACY_DASHBOARD_PREFIXES = ["influencer-campaign-list-pagination:"];

const parseStoredInfluencer = () => {
  try {
    return JSON.parse(localStorage.getItem("influencer")) || {};
  } catch {
    return {};
  }
};

export const getInfluencerDashboardScope = ({ email, influencer } = {}) => {
  const storedInfluencer = parseStoredInfluencer();
  const identifier =
    email ||
    influencer?.Email ||
    influencer?.email ||
    influencer?._id ||
    storedInfluencer?.Email ||
    storedInfluencer?.email ||
    storedInfluencer?._id ||
    localStorage.getItem("email") ||
    "anonymous";

  return encodeURIComponent(String(identifier).trim().toLowerCase());
};

export const getInfluencerDashboardStorageKey = (key, scopeOptions) =>
  `${DASHBOARD_STATE_PREFIX}:${getInfluencerDashboardScope(scopeOptions)}:${key}`;

export const clearInfluencerDashboardState = () => {
  Object.keys(sessionStorage).forEach((key) => {
    if (
      key.startsWith(`${DASHBOARD_STATE_PREFIX}:`) ||
      LEGACY_DASHBOARD_KEYS.includes(key) ||
      LEGACY_DASHBOARD_PREFIXES.some((prefix) => key.startsWith(prefix))
    ) {
      sessionStorage.removeItem(key);
    }
  });
};
